export class Terminales {
            public codTerminalVenta: number;
            public descripcion: string;
            public id: string;
            public codSucursal: number;
            public codEmpresa: number;
            public disponible: boolean;
            constructor() { }
    }
